// l10n status: partial
import { CircularProgress, Slide, Snackbar, SnackbarContent } from "@mui/material"
import { CreateComponent } from "components/utils/CreateComponent"
import React, { forwardRef, useImperativeHandle, useState } from "react"
import { ConfirmationDialog } from "components/ConfirmationDialog"
//import { RecordingsStartDialog } from "scenes/Recordings/components/RecordingsStartDialog"
import { RecordingsStartDialog } from "components/RecordingsStartDialog"
import { RECORDING_OPTIONS } from "store/page/recordings/RecordingsManager"
import { rootStore } from "store/RootStore"
import { EventEmitter } from "components/utils/EventEmitter"
import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import { ButtonGeneric, ButtonVisibility, ButtonArchive } from "scenes/components/ButtonComponents"
import { computed } from "mobx"
import { eventId, season, episode, isSeries, title } from "utils/EventHelpers"
import { l10n } from "store/lang/L10n"


const style = theme => ({
	recordingsSnackbar: {
		background: "#4C4C4C", //theme.palette.secondary.main,
		//color: theme.palette.text.primary,
		color: "#FFF !important",
		// MTVW-379: When a recording was started, the snackbar in full screen mode was positioned on top of the center player
		// controls and blocking those controls, even when the snackbar disappeared
		position: "absolute",
		top: "-150px",
		backgroundColor: "#4C4C4C !important", //theme.palette.secondary.main + "!important",
		justifyContent: "center"
	},
	recordingsLoader: {
		position: "absolute",
		top: "50%",
		left: "50%"
	},
})

export const RecordingsManager = CreateComponent(
	style,
	false,
	true,
	forwardRef(({ classes, oEvent, buttonFunction, onEnd, isPrevMenu = false, isSingleButton = false }, ref) => {
		const eventManager = rootStore.page.Recordings.Manager.getRecordingEvent(oEvent)
		const marker = rootStore.page.Recordings.Manager.getMarker(eventId(oEvent))
		//const marker = computed(() => rootStore.page.Recordings.Manager.getMarker(eventId(oEvent))).get()
		console.debug("RecordingsManager marker", marker, eventManager)

		//console.debug("-----------> buttonFunction: " + buttonFunction)

		const [optionsDeleteRecording, setOptionsDeleteRecording] = useState(buttonFunction ?? null)
		const [optionsRecording, setOptionsRecording] = useState([])
		const [optionsMore, setOptionsMore] = useState([])
		const [optionsInfo, setOptionsInfo] = useState(null)

		const [textSnackbar, setTextSnackbar] = useState(null)

		const context = rootStore.page.OverlayEventDetails.callingContext
		if (rootStore.page.Recordings.Manager.oRecEvent.error) {
			//console.debug("rootStore.page.Recordings.Manager.oRecEvent.error" + rootStore.page.Recordings.Manager.oRecEvent.error)
		}
		//else console.debug("NO rootStore.page.Recordings.Manager.error")
		//eventManager.handleEpisodeRecord()

		useImperativeHandle(ref, () => ({
			setTypeRecording: (recOptions) => {
				//console.debug("setTypeRecording", recOptions)
				setOptionsRecording(recOptions)
			},
			setTypeDelete: (name) => {
				setOptionsDeleteRecording(name)
			},
			setTypeMore: (button) => {
				//console.debug("setTypeMore", button)
				setOptionsMore(button)
			},
			setTypeInfo: (profile) => {
				setOptionsInfo(profile)
			},
			// MTVW-820: Make onAcceptHandler accessible for parent RecordingButtons
			onAcceptHandler: (props) => {
				onAcceptHandler(props)
			}
		}))

		const onAcceptHandler = props => {
			console.debug("onAcceptHandler", props)

			// MTV-3062 
			//in the case of series, the user can choose  if he wants to record one episode or the series in RecordingStartDialog
			// So is possible to define what callback call only here 
			let callbackName = props.callbackName ? props.callbackName : props.recordSeries ? "handleSerieRecord" : "handleEpisodeRecord"


			if (callbackName) {
				eventManager.setLoaderVisible(true)
				eventManager[callbackName](props).then(() => {
					eventManager.setLoaderVisible(true)
					rootStore.api
						.GetRecordingsMarkers()
						.fetchDataAsync()
						.finally(() => {
							// MTV-1776: close EventDetails when delete a recording in Aufnahmen section
							// MTV-2940: dont close if in TvLive, TvGuide, RelatedContent
							if (context === CALLING_CONTEXT_TYPE.Recording) {
								// MTVW-499
								if (callbackName === "handleEpisodeDelete" ||
									callbackName === "handleSeriesDelete" ||
									callbackName === "handleSeriesCancel") EventEmitter.dispatch("closeOverlayDialog", null)
							}
							// MTV-1736: refresh page
							rootStore.page.Recordings.IndexPage.refreshData()
							rootStore.page.Recordings.ListPage.refreshData()
							eventManager.setLoaderVisible(false)
							setTextSnackbar(`${props.snackbarText}`)
						})
				}).catch((e) => {
					console.error("onAcceptHandler", e)
				})
				setOptionsDeleteRecording(null)
				setOptionsRecording([])
				setOptionsMore(null)
				setOptionsInfo(null)
			}
		}

		const onCloseSnackbar = () => {
			setTextSnackbar(null)
			if (onEnd) {
				onEnd()
			}
		}

		const onCancelHandler = () => {
			setOptionsDeleteRecording(null)
			setOptionsRecording([])
			setOptionsMore(null)
			setOptionsInfo(null)
			setTextSnackbar(null)
			if (onEnd) {
				onEnd()
			}
		}

		// TODO: this code  will never run ... singlebutton will never be equal to true
		/*
		if (isSingleButton === true) {
			const buttons = eventManager.buttonsLists
			console.log("buttons=%o", buttons)
			if (buttons[RECORDING_OPTIONS.series_episode_record] || buttons[RECORDING_OPTIONS.series_record])
				return <RecordingsStartDialog title="Einzelaufnahme!!!" additionalInfo={null} onButtonHandlerA={onCancelHandler} onButtonHandlerB={onAcceptHandler} buttonTextA={l10n.commonActionCancel} buttonTextB={l10n.commonActionRecord} />
		}
		*/
		// Weiterhin aufnehmen
		// Aufnahme abbrechen

		console.debug("RecordingsManager Season %o, Episode %o isSeries %o, event %o, optionsRecording %o", season(oEvent), episode(oEvent), isSeries(oEvent), oEvent, optionsRecording)
		if (!season(oEvent) && episode(oEvent)) console.warn("NO SEASON, episode %o", episode(oEvent))
		return (
			<>
				<Snackbar open={textSnackbar !== null && textSnackbar !== "undefined"} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={onCloseSnackbar}
					slots={{
						transition: props => <Slide {...props} direction="left" data-test="message" />
					}}
				>
					<SnackbarContent className={classes.recordingsSnackbar} message={<div>{textSnackbar}</div>}></SnackbarContent>
				</Snackbar>
				{eventManager.isLoading && <CircularProgress className={classes.recordingsLoader}></CircularProgress>}

				{/*console.debug("optionsRecording", optionsRecording, optionsRecording.length, optionsRecording[0] === RECORDING_OPTIONS.episode_record)*/}
				{/* user has to choose single episode or series record */}
				{optionsRecording?.length === 2 && (
					<RecordingsStartDialog
						title={l10n.commonLabelRecording}
						additionalInfo={null}
						onCloseHandler={onCancelHandler}
						onAcceptHandler={onAcceptHandler}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecord_confirm`, variant: "primary",
									label: l10n.dialogRecordEpisodeLabel, //season(oEvent) ? l10n.dialogRecordSeasonNumberLabel.format(season(oEvent)) : l10n.dialogRecordEpisodeLabel,
									// confirm button will be intercepted in RecordingsStartDialog
									isConfirmButton: true,
									onClick: function () { },
									dataTest: "confirm"
								}
							}
							]}
						flagSeriesDefaultValue={null}
						oEvent={oEvent}
						// callbackName="handleEpisodeRecord"
						// no snackbarText, immediately handled with setTargetMarker
						snackbarText={`${l10n.featureDetailsRecordingStatusInProgress} ${title(oEvent)} `}
					/>
				)}

				{/* single only, no series */}
				{optionsRecording[0] === RECORDING_OPTIONS.episode_record && (
					<RecordingsStartDialog
						title={l10n.commonLabelRecording}
						additionalInfo={null}
						onCloseHandler={onCancelHandler}
						onAcceptHandler={onAcceptHandler}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecord_confirm`, variant: "primary",
									label: l10n.dialogRecordSingleLabel,
									// confirm button will be intercepted in RecordingsStartDialog
									isConfirmButton: true,
									onClick: function () { },
									dataTest: "confirm"
								}
							}
							]}
						flagSeriesDefaultValue={false}
						oEvent={oEvent}
						callbackName="handleEpisodeRecord"
					// no snackbarText, immediately handled with setTargetMarker
					//snackbarText={`${title(oEvent)} Wird aufgezeichnet`}
					/>
				)}
				{/* MTV-3062	 */}
				{/* {optionsRecording === RECORDING_OPTIONS.series_episode_record && (
					<RecordingsStartDialog
						title="Einzelaufnahme"
						additionalInfo={null}
						onButtonHandlerA={onCancelHandler}
						onButtonHandlerB={onAcceptHandler}
						buttonTextA={isPrevMenu ? l10n.commonActionBack : l10n.commonActionCancel}
						buttonTextB={l10n.commonActionRecord}
						callbackName="handleEpisodeRecord"
						snackbarText={`${title(oEvent)} Wird aufgezeichnet`}
					/>
				)} */}
				{/* {optionsRecording === RECORDING_OPTIONS.series_record && (
					<RecordingsStartDialog
						title="Serienaufnahme"
						additionalInfo={null}
						onButtonHandlerA={onCancelHandler}
						onButtonHandlerB={onAcceptHandler}
						buttonTextA={isPrevMenu ? l10n.commonActionBack : l10n.commonActionCancel}
						buttonTextB={l10n.commonActionRecord}
						callbackName="handleSerieRecord"
						snackbarText={`${title(oEvent)} Wird aufgezeichnet`}
					/>
				)} */}

				{optionsRecording[0] === RECORDING_OPTIONS.series_record_add && (
					<RecordingsStartDialog
						title={l10n.commonLabelRecording}
						additionalInfo={null}
						onCloseHandler={onCancelHandler}
						onAcceptHandler={onAcceptHandler}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecord_confirm`, variant: "primary",
									label: season(oEvent) ? l10n.dialogRecordSeasonNumberLabel.format(season(oEvent)) : l10n.dialogRecordSeriesLabel,
									// confirm button will be intercepted in RecordingsStartDialog
									isConfirmButton: true,
									onClick: function () { },
									dataTest: "confirm"
								}
							}
							]}
						oEvent={oEvent}
						flagSeriesDefaultValue={true}
						callbackName="handleSerieRecord"
						//no snackbarText, immediately handled with setTargetMarker
						snackbarText={`${l10n.featureDetailsRecordingStatusInProgress} ${title(oEvent)} `}
					/>
				)}

				{optionsDeleteRecording === RECORDING_OPTIONS.episode_cancel && (
					<div>
						{/* cancel without confirmation */}
						{onAcceptHandler({
								callbackName: "handleEpisodeDelete",
								snackbarText: l10n.featureSingleRecordingCancelled
							})
						}
						{/*
						<ConfirmationDialog
							title="Aufnahme abbrechen?"
							onCloseHandler={onCancelHandler}
							bottomButtons={
								[{
									bType: ButtonGeneric,
									props: {
										bId: `buttonRecordEpisode_cancel`, variant: "primary",
										label: l10n.dialogCancelRecordingAction, // "Aufnahme abbrechen"
										onClick: function () {
											return onAcceptHandler({ callbackName: "handleEpisodeDelete", snackbarText: "Einzelaufnahme abgebrochen" })
										},
										dataTest: "cancel"
									}
								},
								{
									bType: ButtonGeneric,
									props: {
										bId: `buttonRecordEpisode_confirm`, variant: "secondary",
										label: l10n.commonActionClose, // "Weiterhin aufnehmen" -> "Schliessen"
										onClick: onCancelHandler,
										dataTest: "confirm"
									}
								}
								]}
						>
							Soll diese Einzelaufnahme abgebrochen werden?
						</ConfirmationDialog>
						*/}
					</div>
				)}

				{optionsDeleteRecording === RECORDING_OPTIONS.series_episode_cancel && (
					<div>
						{/* cancel without confirmation */}
						{onAcceptHandler({
											callbackName: "handleEpisodeDelete",
											snackbarText: l10n.featureSingleRecordingCancelled
										})}
						{/*
						<ConfirmationDialog
							title="Geplante Aufnahme abbrechen?"
							onCloseHandler={onCancelHandler}
							bottomButtons={
								[{
									bType: ButtonGeneric,
									props: {
										bId: `buttonRecordEpisode_cancel`, variant: "primary",
										label: l10n.dialogCancelRecordingAction, // "Aufnahme abbrechen"
										onClick: function () {
											return onAcceptHandler({ callbackName: "handleEpisodeDelete", snackbarText: "Einzelaufnahme abgebrochen" })
										},
										dataTest: "cancel"
									}
								},
								{
									bType: ButtonGeneric,
									props: {
										bId: `buttonRecordEpisode_confirm`, variant: "secondary",
										label: l10n.commonActionClose, // "Auswahl ändern -> "Schliessen"
										onClick: onCancelHandler,
										dataTest: "confirm"
									}
								}
								]}
						>
							Soll die geplante Einzelaufnahme abgebrochen werden? Die Serie wird weiterhin aufgenommen.
						</ConfirmationDialog>
						*/}
					</div>
				)}

				{optionsDeleteRecording === RECORDING_OPTIONS.series_cancel && (
					<ConfirmationDialog
						title={l10n.dialogSeriesCancelTitle}
						onCloseHandler={onCancelHandler}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecordEpisode_cancel`, variant: "primary",
									label: l10n.dialogCancelRecordingAction, // "Aufnahme abbrechen"
									onClick: function () {
										return onAcceptHandler({
											callbackName: "handleSeriesCancel",
											snackbarText: l10n.featureSeriesRecordingCancelled
										})
									},
									dataTest: "cancel"
								}
							},
							{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecordEpisode_confirm`, variant: "secondary",
									label: l10n.commonActionClose, // "Auswahl ändern" -> "Schliessen"
									onClick: onCancelHandler,
									dataTest: "confirm"
								}
							}
							]}
					>
						{l10n.dialogSeriesCancelDescription.replaceAll("\\n", "\n")}
					</ConfirmationDialog>
				)}

				{optionsDeleteRecording === RECORDING_OPTIONS.series_episode_delete && (
					<ConfirmationDialog
						title={l10n.dialogSeriesEpisodeDeleteTitle}
						onCloseHandler={onCancelHandler}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecordEpisode_cancel`, variant: "primary",
									label: l10n.dialogDeleteRecordingAction, // "Aufnahme löschen"
									onClick: function () {
										return onAcceptHandler({
											callbackName: "handleEpisodeDelete",
											snackbarText: l10n.featureSingleRecordingDeleted
										})
									},
									dataTest: "cancel"
								}
							},
							{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecordEpisode_confirm`, variant: "secondary",
									label: l10n.commonActionClose, // "Auswahl ändern" -> "Schliessen"
									onClick: onCancelHandler,
									dataTest: "confirm"
								}
							}
							]}
					>
						{l10n.dialogSeriesEpisodeDeleteDescription.replaceAll("\\n", "\n")}
					</ConfirmationDialog>
				)}

				{optionsDeleteRecording === RECORDING_OPTIONS.episode_delete && (
					<ConfirmationDialog
						title={l10n.dialogEpisodeDeleteTitle}
						onCloseHandler={onCancelHandler}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecordEpisode_cancel`, variant: "primary",
									label: l10n.dialogDeleteRecordingAction, // "Aufnahme löschen"
									onClick: function () {
										return onAcceptHandler({
											callbackName: "handleEpisodeDelete",
											snackbarText: l10n.featureSingleRecordingDeleted
										})
									},
									dataTest: "cancel"
								}
							},
							{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecordEpisode_confirm`, variant: "secondary",
									label: l10n.commonActionClose, // "Aufnahme behalten" -> "Schliessen"
									onClick: onCancelHandler,
									dataTest: "confirm"
								}
							}
							]}
					>
						{l10n.dialogEpisodeDeleteDescription.replaceAll("\\n", "\n")}
					</ConfirmationDialog>
				)}

				{optionsDeleteRecording === RECORDING_OPTIONS.series_delete && (
					<ConfirmationDialog
						title={l10n.dialogDeleteSeriesTitle}
						onCloseHandler={onCancelHandler}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecordEpisode_cancel`, variant: "primary",
									label: l10n.dialogDeleteRecordingsAction, // "Aufnahmen löschen"
									onClick: function () {
										return onAcceptHandler({
											callbackName: "handleSeriesDelete",
											snackbarText: l10n.featureSeriesRecordingDeleted
										})
									},
									dataTest: "cancel"
								}
							},
							{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecordEpisode_confirm`, variant: "secondary",
									label: l10n.commonActionClose, // "Auswahl ändern" -> "Schliessen"
									onClick: onCancelHandler,
									dataTest: "confirm"
								}
							}
							]}
					>
						{l10n.dialogDeleteSeriesDescription.replaceAll("\\n", "\n")}
					</ConfirmationDialog>
				)}

				{/* see isInRecordingWindow in RecordingButtons*/}
				{optionsDeleteRecording === RECORDING_OPTIONS.archive_remove && (
					<ConfirmationDialog
						title={l10n.dialogRemoveFromArchiveTitle}
						onCloseHandler={onCancelHandler}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonArchiveRemove_cancel`, variant: "primary",
									label: l10n.dialogDeleteRecordingAction, // "Aufnahme löschen"
									onClick: function () {
										return onAcceptHandler({
											callbackName: "handleEpisodeDelete",
											snackbarText: l10n.featureRecordingDeleted
										})
									},
									dataTest: "cancel"
								}
							},
							{
								bType: ButtonGeneric,
								props: {
									bId: `buttonArchiveRemove_confirm`, variant: "secondary",
									label: l10n.commonActionClose, // "Auswahl ändern" -> "Schliessen"
									onClick: onCancelHandler,
									dataTest: "confirm"
								}
							}
							]}
					>
						{l10n.dialogRemoveFromArchiveDescription.replaceAll("\\n", "\n")}
					</ConfirmationDialog>
				)}

				{/*console.debug("optionsMore", optionsMore)*/}
				{/* "Aufnahmeoptionen" could be hidden with the 2nd condition, but opacity would flash */}
				{optionsMore?.length > 0 /*&& !(optionsRecording[0] === RECORDING_OPTIONS.series_record_add)*/ &&
					<ConfirmationDialog
						title={l10n.dialogRecordingOptionsTitle}
						onCloseHandler={onCancelHandler}
						bodyButtons={optionsMore}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecordEpisode_confirm`, variant: "primary",
									label: l10n.commonActionClose, // "Auswahl ändern -> "Schliessen"
									onClick: onCancelHandler,
									dataTest: "confirm"
								}
							}
							]}
					>
						{/*Soll die geplante Einzelaufnahme abgebrochen werden? Die Serie wird weiterhin aufgenommen.*/}
					</ConfirmationDialog>
				}

				{/*console.debug("optionsInfo", optionsInfo)*/}
				{optionsInfo?.length > 0 &&
					<ConfirmationDialog
						title={l10n.dialogSharedRecordingTitle}
						onCloseHandler={onCancelHandler}
						bodyButtons={optionsInfo}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonRecordEpisode_confirm`, variant: "primary",
									label: l10n.commonActionClose, // "Auswahl ändern -> "Schliessen"
									onClick: onCancelHandler,
									dataTest: "confirm"
								}
							}
							]}
					>
						{l10n.dialogSharedRecordingDescription.format(rootStore.sso.getProfile(marker?.ProfileId)?.name).replaceAll("\\n", "\n")}
					</ConfirmationDialog>
				}
			</>
		)
	})
)
